'use client';

import { Error as ErrorComponent, ErrorProps } from '../../../components/error/Error';
import { Center } from '../../../styles';

export default function CustomErrorPage({ error, reset }: ErrorProps) {
    return (
        <Center style={{ minHeight: '100vh', textAlign: 'center' }}>
            <ErrorComponent error={error} reset={reset} />
        </Center>
    );
}
